// @flow

import type { Dispatch } from 'redux';
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';

import {
  createResource,
  type FetchResponse,
  type Resource,
} from '@gandi/resource/redux';

import type { FullState, ThunkAction as BaseThunkAction } from '../../types';
import type { CorpoPackDetail, CorporateState } from '../types';

export type FetchOneCorpoPackAction<R> = (orgId: string) => R;

export type ThunkAction = BaseThunkAction<Promise<any>>;

// ********** RESOURCE **********

export const corporateResource: Resource<> = createResource('corporate');

// ********** ACTIONS **********

export const fetchOneCorpoPack: FetchOneCorpoPackAction<ThunkAction> =
  orgId =>
  (
    // $FlowFixMe[missing-type-arg]
    dispatch: Dispatch,
  ) =>
    dispatch(
      corporateResource.fetchOne(`/corporate/packs?sharing_id=${orgId}`, {
        label: orgId,
      }),
    );

// ********** SELECTORS **********

export const selectCorpoPack: (
  state: FullState,
  props: string, // $FlowFixMe[incompatible-call]
) => Array<CorpoPackDetail> = createSelector(
  [
    (state: FullState) => state.configure.corporate,
    (_: any, orgId: string) => orgId,
  ],
  (corpoPack: CorporateState, orgId: string): Array<CorpoPackDetail> =>
    corpoPack[orgId],
);

// ********** HANDLERS **********

export const fetchOneCorpoPackHandler = (
  state: CorporateState,
  {
    response,
    label,
  }: {
    response: FetchResponse<200, CorpoPackDetail>,
    label: string,
  },
): { [string]: Array<CorpoPackDetail>, ... } => ({
  ...state,
  // $FlowFixMe[incompatible-type] TODO: Fix type
  [label]: response.data,
});

// ********** REDUCER **********

export const initialState: CorporateState = {};

const reducer: {
  (): (state: CorporateState, payload?: mixed, meta?: mixed) => CorporateState,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<CorporateState>,
  options: () => mixed,
  ...
} = createReducer(
  {
    [corporateResource.fetchOne.success.getType()]: fetchOneCorpoPackHandler,
  },
  initialState,
);

export default reducer;
